import { Injectable, ApplicationRef, ComponentFactoryResolver, Injector, ComponentRef, EmbeddedViewRef, Input } from '@angular/core';
import { ModalComponent } from './modal.component';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private modalRef?: ComponentRef<ModalComponent>;

  constructor(
    private appRef: ApplicationRef,
    private injector: Injector,
    private resolver: ComponentFactoryResolver
  ) {}

  open(component: any, relatedData: any): ComponentRef<any> {

    if (!this.modalRef) {
      const factory = this.resolver.resolveComponentFactory(ModalComponent);
      this.modalRef = factory.create(this.injector);
      
      this.modalRef.instance.relatedData = relatedData;

      this.appRef.attachView(this.modalRef.hostView);

      const domElem = (this.modalRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
      document.body.appendChild(domElem);

      this.modalRef.instance.close = this.close.bind(this);
      

      
    }
    setTimeout(() => {
      if (this.modalRef) {
        this.modalRef.instance.loadComponent(component);
      }
    }, 0);

    return this.modalRef!;
  }

  close() {
    if (this.modalRef) {
      // this.modalRef.close();
      document.body.style.overflow = 'auto';
      this.appRef.detachView(this.modalRef.hostView);
      this.modalRef.destroy();
      this.modalRef = undefined;
    }
  }
}